import React, { useState, useEffect } from "react";

import SkincareStepsComponent from "../../components/skincareSteps";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { getSkinProfileApi } from "../../services/skinProfile.service";
import { getSkincareStepsApi } from "../../services/skincare.service";
// import { data } from '../../mockData/holisticData';
import PageLoader from "../../components/common/loader/pageLoader";

interface SkincareStepsContainerInterface {}

const SkincareStepsContainer: React.FC<
  SkincareStepsContainerInterface
> = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>();
  const [tips, setTips] = useState<string>();
  const [note, setNote] = useState<string>();

  useEffect(() => {
    setLoading(true);
    fetchSkincareStepsData();
    fetchSkinProfile();
  }, []);

  const fetchSkincareStepsData = () => {
    dispatch(
      getSkincareStepsApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data?: any) => {
          setData(data);
        },
      })
    );
  };

  const fetchSkinProfile = () => {
    setLoading(true);
    dispatch(
      getSkinProfileApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data: any) => {
          setTips(data?.response?.product_tips);
          setNote(data?.response?.note_file);
        },
        unAunthicatedCallback: () => {},
      })
    );
  };

  if (loading) {
    return <PageLoader />;
  }

  return <SkincareStepsComponent data={data} note={note} tips={tips} />;
};

export default SkincareStepsContainer;
